module.exports = __webpack_public_path__ + "img/scqz.79694873.png";